import { logCardImpressions } from "./log-card-impressions.js";
export function logContentCardImpressions(o) {
  return logCardImpressions(o, !0);
}
